// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import {Clients,EnvironmentEnum,GoogleApiKey,GoogleCaptchaKey,Icons,Loader,Logo,ServerUrl} from "./clients";

export const environment = {
  production: false,
  login: Clients.TDIS,
  environment: EnvironmentEnum.TDIS_TEST,
  logo: Logo.TDIS,
  loader: Loader.TDIS,
  icons: Icons.TDIS,
  serverUrl: ServerUrl.TDIS_TEST,
  googleApiKey: GoogleApiKey.TDIS_TEST,
  googleCaptchaKey: GoogleCaptchaKey.TDIS_TEST,
  spotEnabled: false,
  claimEnabled: false,
  blockchainEnabled: true
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
